module.exports = __webpack_public_path__ + "img/Heinrich.9361260e.png";